<donut-input-checkbox v-model="installWizardEmailMarketingOptIn" label="I agree to receive emails from Donut."></donut-input-checkbox>